import { gql } from "@apollo/client/core";
import fragments from '../fragments'

export default gql`
    ${fragments.Prevention.PreventionCategory_Minimal}
    mutation CreatePreventionCategory($title: String!, $description: String) {
        createPreventionCategory(input: { title: $title, description: $description }) {
            errors
            status
            statusCode
            preventionCategory {
                ...PreventionCategory_Minimal
            }
        }
    }
`
